import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, getDoc, doc,query, where,updateDoc, onSnapshot   } from 'firebase/firestore';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';
import cats from '../../assets/images/Group.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus, faMinus,faCircle } from '@fortawesome/free-solid-svg-icons';
import { Carousel } from 'react-bootstrap';

const Boutique = () => {
    const [plats, setPlats] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [panier, setPanier] = useState([]);
    const [showPickupTimeModal, setShowPickupTimeModal] = useState(false);
    const [showDisableCommModal, setShowDisableCommModal] = useState(false);
    const [showFermetureModal, setShowFermetureModal] = useState(false);
    const [showQuantityModal, setShowQuantityModal] = useState(false);
    const [selectedPlat, setSelectedPlat] = useState(null);
    const [pickupTime, setPickupTime] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [horairesOuverture, setHorairesOuverture] = useState([]);
    const [availablePickupTimes, setAvailablePickupTimes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [pickupTimeError, setPickupTimeError] = useState(false);
    const [notification, setNotification] = useState({ visible: false, message: '' });
    const [selectedSize, setSelectedSize] = useState(selectedPlat?.sizes[0]?.prix || selectedPlat?.prix);
    const [selectedModules, setSelectedModules] = useState([]);
    const [selectedSizePrice, setSelectedSizePrice] = useState(0);
    const selectedModulesPrice = selectedModules.reduce((total, module) => total + module.prix, 0);
    const [acceptCommandes, setAcceptCommandes] = useState(null);
    const [specialInstructions, setSpecialInstructions] = useState('');
    const storedPanier = localStorage.getItem('panier');
    const parsedPanier = storedPanier ? JSON.parse(storedPanier) : [];


    const navigate = useNavigate();

    useEffect(() => {
        const parseDate = (dateString) => {
            // Convertir la chaîne "DD/MM/YYYY HH:MM:SS" en objet Date
            const [datePart, timePart] = dateString.split(' ');
            const [day, month, year] = datePart.split('/').map(Number);
            const [hours, minutes, seconds] = timePart.split(':').map(Number);
            return new Date(year, month - 1, day, hours, minutes, seconds);
        };
    
        const checkDailyCommandes = async () => {
            try {
                const configDoc = doc(db, 'config', 'orderStatus');
                
                // Écouter en temps réel les changements du document de configuration
                onSnapshot(configDoc, async (configSnap) => {
                    if (configSnap.exists()) {
                        const config = configSnap.data();
                        const today = new Date();
                        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                        const todayEnd = new Date(todayStart);
                        todayEnd.setDate(todayEnd.getDate() + 1);
    
                        const commandesQuery = query(collection(db, 'commande'));
                        const snapshot = await getDocs(commandesQuery);
    
                        let commandesDuJour = 0;
    
                        snapshot.forEach((doc) => {
                            const data = doc.data();
                            const dateCommande = parseDate(data.date_commande); // Convertir la chaîne en objet Date
                            
                            // Vérifier si la commande est du jour et si son statut n'est pas "Annulé" ou "Refusé"
                            if (dateCommande >= todayStart && dateCommande < todayEnd && 
                                data.statut_commande !== 'Annulé' && data.statut_commande !== 'Refusé') {
                                commandesDuJour++;
                            }
                        });
            
                        // Activer ou désactiver les commandes selon la configuration
                        if (commandesDuJour >= config.max_commandes_par_jour || !config.accept_commandes || !config.max_commande) {
                            setShowDisableCommModal(true);
                        } else {
                            setShowDisableCommModal(false);
                        }
    
                        // Mise à jour dans Firestore si nécessaire
                        await updateDoc(configDoc, {
                            max_commande: commandesDuJour < config.max_commandes_par_jour
                        });
                    } else {
                        console.log("Le document de configuration n'existe pas.");
                    }
                });
            } catch (error) {
                console.error("Erreur lors de la vérification des commandes :", error);
            }
        };
    
        checkDailyCommandes();
    }, []);
    
    
    useEffect(() => {
        const checkOrderStatus = () => {
          const docRef = doc(db, 'config', 'orderStatus');
          
          // Écouter les changements en temps réel du statut de la commande
          onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
              const data = docSnap.data();
            
    
              if (!data.accept_commandes || !data.max_commande) {
                setAcceptCommandes(false);
                setShowDisableCommModal(true); // Afficher le modal si les commandes sont désactivées
              } else {
                setAcceptCommandes(true);
                setShowDisableCommModal(false); // Masquer le modal si les commandes sont activées
              }
            }
          });
        };

        const checkFermetures = async () => {
            const today = new Date();
            const fermeturesSnapshot = await getDocs(collection(db, 'fermetures'));
            const fermetures = fermeturesSnapshot.docs.map(doc => doc.data());
    
            let isClosed = false;
           
            fermetures.forEach((fermeture) => {
                if (fermeture.type === 'jour') {
                    
                    // Comparer la date actuelle à un jour de fermeture
                    const fermetureDate = new Date(fermeture.date);
                    if (fermetureDate.toDateString() === today.toDateString()) {
                        isClosed = true;
                       
                    }
                } else if (fermeture.type === 'periode') {
                  
                    // Vérifier si la date actuelle se trouve dans une période de fermeture
                    const dateDebut = new Date(fermeture.date_debut);
                    const dateFin = new Date(fermeture.date_fin);
                    if (today >= dateDebut && today <= dateFin) {
                        
                        isClosed = true;
                    }
                }
            });
    
            // Si c'est un jour ou une période de fermeture, désactiver les commandes
            if (isClosed) {
                setAcceptCommandes(false);
                setShowFermetureModal(true); // Afficher le modal
            } else {
                setAcceptCommandes(true);
                setShowFermetureModal(false); // Masquer le modal
            }
        };
   
    
        checkOrderStatus();
        checkFermetures ();
       
    }, []);

    useEffect(() => {
        if (selectedPlat?.sizes && selectedPlat.sizes.length > 0) {
            setSelectedSize(selectedPlat.sizes[0]); // Sélectionner la première taille par défaut
        } else {
            setSelectedSize(null); // Réinitialiser si aucune taille n'est disponible
        }
    }, [selectedPlat]);
   
    useEffect(() => {
        const fetchPlats = async () => {
            try {
                const platsCollection = collection(db, 'food-items');
                const platsSnapshot = await getDocs(platsCollection);
                const platsList = platsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setPlats(platsList);
            } catch (error) {
                console.error("Error fetching plats: ", error);
            }
        };

        const fetchCategories = async () => {
            try {
                const categoriesCollection = collection(db, 'categorie');
                const categoriesSnapshot = await getDocs(categoriesCollection);
                const categoriesList = categoriesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setCategories(categoriesList);
            } catch (error) {
                console.error("Error fetching categories: ", error);
            }
        };

        const fetchHorairesOuverture = async () => {
            try {
                const horairesCollection = collection(db, 'horaires');
                const horairesSnapshot = await getDocs(horairesCollection);
                const horairesList = horairesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setHorairesOuverture(horairesList);
           
            } catch (error) {
                console.error("Error fetching horaires: ", error);
            }
        };

        fetchPlats();
        fetchCategories();
        fetchHorairesOuverture();
    }, []);

    useEffect(() => {
  
        if (parsedPanier.length && horairesOuverture.length) {
            const today = new Date().toLocaleDateString('fr-FR', { weekday: 'long' }).toLowerCase();
            const currentSeason = getCurrentSeason(); // Fonction pour déterminer la saison actuelle
            const horaires = horairesOuverture.find(h => h.jour === today);
      
            if (horaires) {
                const seasonHoraires = horaires.saisons[currentSeason] || [];
                const availableTimes = generateAvailableTimes(seasonHoraires);
                setAvailablePickupTimes(availableTimes);
            } else {
                setAvailablePickupTimes([]);
            }
        }
    }, [parsedPanier, horairesOuverture]);
    
    const getCurrentSeason = () => {
        const month = new Date().getMonth() + 1; // January is 0
        if (month >= 1 || month <= 5) return 'hiver';
        if (month >= 6 && month <= 9) return 'été';
        if (month >= 10 || month <= 12) return 'hiver';
        return 'autre'; // Adjust if you have more seasons
    };

    const generateAvailableTimes = (horaires) => {
        const availableTimes = [];
        const now = new Date();
        
        // Ajouter 20 minutes à l'heure actuelle
        now.setMinutes(now.getMinutes() + 20);
        
        // Arrondir au prochain intervalle de 15 minutes
        const minutes = now.getMinutes();
        const roundedMinutes = Math.ceil(minutes / 15) * 15;
        now.setMinutes(roundedMinutes);
        now.setSeconds(0); // Réinitialiser les secondes à 0
    
        const currentTime = now.toTimeString().substring(0, 5);
        
        horaires.forEach(({ début, fin }) => {
            let startTime = new Date(`1970-01-01T${début}:00`);
            const endTime = new Date(`1970-01-01T${fin}:00`);
            
            // Vérifier si l'heure actuelle ajustée est avant la fin de la plage horaire
            if (currentTime <= endTime.toTimeString().substring(0, 5)) {
                // Si l'heure de début est avant l'heure actuelle, ajuster l'heure de début à l'heure actuelle
                if (startTime.toTimeString().substring(0, 5) < currentTime) {
                    startTime = new Date(`1970-01-01T${currentTime}:00`);
                }
                
                // Cloner startTime pour éviter de modifier l'heure de début originale
                let tempStartTime = new Date(startTime);
    
                // Générer les heures disponibles
                while (tempStartTime <= endTime) {
                    availableTimes.push(tempStartTime.toTimeString().substring(0, 5));
                    tempStartTime.setMinutes(tempStartTime.getMinutes() + 15); // Intervalle de 15 minutes
                }
            }
        });
    
        return availableTimes;
    };
    
    
    
    
    
    const filteredPlats = plats
    .filter(plat => 
        plat.categorie === selectedCategory || !selectedCategory
    )
    .filter(plat => 
        plat.nom.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(
            searchTerm.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        ) || 
        plat.description.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(
            searchTerm.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        )
    );
    


    const handleAddToPanier = (plat) => {
        setSelectedPlat(plat);
        setShowQuantityModal(true); 
    };

    const handlePickupTimeSubmit = () => {
        if (!pickupTime) {
            setPickupTimeError(true);
            return;
        }
        setPickupTimeError(false);
        setShowPickupTimeModal(false);
    
        navigate('/checkout', { state: { pickupTime } });
    };
    

    const handleQuantitySubmit = () => {
        // Filtrer les modules qui correspondent au plat sélectionné par son platId
        const filteredAddons = selectedModules
            .filter(item => item.platId === selectedPlat.id)
            .map(item => item.addons); // Récupérer uniquement les addons pour le plat correspondant
    
        const platInfo = {
            id: selectedPlat.id,
            image: selectedPlat.image,
            nom: selectedPlat.nom,
            prix: selectedPlat?.prixType === 'variable' ? selectedSize.prix : selectedPlat.prix,
            taille: selectedPlat?.prixType === 'variable' ? selectedSize.taille : null,
            addons: filteredAddons.flat(), // Aplatir le tableau des addons s'il y a plusieurs niveaux
            instructions: specialInstructions,
        };
    
        // Ajouter au panier
        addToPanier(platInfo, quantity);
        handleAddToCart(platInfo);
    
        // Réinitialiser les variables
        setSelectedSizePrice();
        setSelectedSize();
        setQuantity(1);
        setShowQuantityModal(false);
         const targetElement = document.getElementById('filter');
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const savePanierToLocalStorage = (panier) => {
    localStorage.setItem('panier', JSON.stringify(panier));
    };


 const addToPanier = (plat, quantity = 1) => {
  setPanier((prevPanier) => {

    // Vérifier si le plat existe déjà dans parsedPanier
    const exists = parsedPanier.some(item => item.id === plat.id);

    // Mise à jour ou ajout du plat dans parsedPanier
    const updatedPanier = exists
      ? parsedPanier.map(item =>
          item.id === plat.id
            ? { ...item, quantity: item.quantity + quantity }
            : item
        )
      : [...parsedPanier, { ...plat, quantity }];

    // Sauvegarder dans localStorage
    savePanierToLocalStorage(updatedPanier);

    // Mettre à jour le state avec updatedPanier
    return updatedPanier;
  });
};


    

  const removeFromPanier = (platId) => {
    setPanier((prevPanier) => {
        const updatedPanier = prevPanier
            .map((item) => {
                // Si l'élément correspond et que la quantité est supérieure à 1, réduire la quantité
                if (item.id === platId && item.quantity > 1) {
                    return { ...item, quantity: item.quantity - 1 };
                }
                // Si la quantité est égale à 1, retourner `null` pour suppression
                if (item.id === platId && item.quantity === 1) {
                    return null; // Marque l'élément à supprimer
                }
                return item; // Conserver les autres éléments
            })
            .filter((item) => item !== null); // Supprimer les éléments marqués comme `null`

        // Sauvegarder dans le localStorage
        savePanierToLocalStorage(updatedPanier);

        return updatedPanier;
    });
};




   

    const handleCheckout = () => {
        if (parsedPanier.length === 0 || acceptCommandes==false ) {
            return;
        }

        setShowPickupTimeModal(true); // Show pickup time modal
    };

    const handleAddToCart = (item) => {
   
       
        setNotification({ visible: true, message: `${item.nom} ajouté avec succès !` });
     
        // Masquer la notification après 3 secondes
        setTimeout(() => {
            setNotification({ visible: false, message: '' });
        }, 3000);
    };
    
   
    
const handleModuleSelection = (platId, addonId, moduleName, modulePrice, isChecked) => {
    setSelectedModules(prevModules => {
        // Recherche de l'addon pour le plat spécifique
        const platIndex = prevModules.findIndex(plat => plat.platId === platId);

        if (platIndex > -1) {
            // Si le plat est déjà dans la liste
            const updatedPlatModules = [...prevModules];

            const addonIndex = updatedPlatModules[platIndex].addons.findIndex(addon => addon.id === addonId);

            if (addonIndex > -1) {
                if (isChecked) {
                    // Mise à jour du module pour cet addon
                    updatedPlatModules[platIndex].addons[addonIndex] = { id: addonId, nom: moduleName, modules: [modulePrice] };
                } else {
                    // Suppression de l'addon si désélectionné
                    updatedPlatModules[platIndex].addons = updatedPlatModules[platIndex].addons.filter(addon => addon.id !== addonId);
                }
            } else {
                if (isChecked) {
                    // Ajouter un nouvel addon au plat
                    updatedPlatModules[platIndex].addons.push({ id: addonId, nom: moduleName, modules: [modulePrice] });
                }
            }

            return updatedPlatModules;
        } else {
            if (isChecked) {
                // Si le plat n'existe pas encore, on l'ajoute avec le nouvel addon
                return [...prevModules, {
                    platId: platId,
                    addons: [{ id: addonId, nom: moduleName, modules: [modulePrice] }]
                }];
            }
        }

        return prevModules;
    });
    
};

const calculateTotalPrice = () => {
    // Définir le prix de base en fonction de la taille sélectionnée ou du plat
    let basePrice = parseFloat(selectedSize?.prix) || parseFloat(selectedPlat?.prix) || 0;

    // Parcourir les addons sélectionnés
    selectedModules.forEach(item => {
        // Vérifier si l'addon contient des modules
        if (item.addons && item.addons.length > 0) {
            // Parcourir chaque addon pour accéder à ses modules
            item.addons.forEach(addon => {
                addon.modules.forEach(mod => {
                    // Ajouter le prix du module au prix de base
                    const prix = parseFloat(mod.prix) || 0;
                    basePrice += prix;
                });
            });
        }
    });

    // Calculer le prix total en fonction de la quantité
    return (basePrice * quantity).toFixed(2);
};


      const handleSizeSelection = (size) => {
        setSelectedSize(size); // Remplace la taille sélectionnée
    };
    const handleCategoryClick = (categoryId) => {
        setSelectedCategory(categoryId);

        // Défilement vers la carte des plats
        const targetElement = document.getElementById('plats-card');
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };
      
    return (
        <div className="mt-5">
        <div>
                {notification.visible && (
                    <div className="notification">
                        {notification.message}
                    </div>
                )}
                {/* Votre composant principal */}
            </div>

            <div className="content mrg-pg">
            <div className="row">
                <div className="col-md-9 pr-4">
                <div className="banner-section banner-acc mb-4">
                    <div className="banner-content d-flex align-items-center justify-content-start">
                        <h2 className="tl-banner">Commande à emporter</h2>
                    </div>
                </div>
                    <div className="row">
                        <div className="col-md-3">
                            <h5 className='tl-filtre d-flex align-items-center justify-content-start'><img className="icn-cat mr-3" src={cats} alt="categorie"/> Catégories</h5>
                            <ul className="list-group mb-5" id='filter'>
                            {/* <li className={`item-filtre ${selectedCategory === '' ? 'active' : ''}`} // Activer la classe active si selectedCategory est vide
                                onClick={() => setSelectedCategory('')}
                                style={{ cursor: 'pointer' }}>Toutes les catégories</li> */}
                            {categories
                            .sort((a, b) => a.ordre - b.ordre) // Tri par ordre croissant
                            .map((category) => (
                                <li
                                key={category.id}
                                className={`item-filtre ${selectedCategory === category.id ? 'active' : ''}`}
                                onClick={() => handleCategoryClick(category.id)}
                                style={{ cursor: 'pointer' }}
                                >
                                {category.nom}
                                </li>
                            ))}
                            </ul>
                        </div>
                        <div className="col-md-9">

                        <div className="input-group mb-4">
                            <span className="input-group-text bg-light border-0 rounded-start serch-icon">
                            <FontAwesomeIcon icon={faSearch} />
                            </span>
                            <input
                                type="text"
                                className="form-control bg-light border-0 rounded-end search-ip"
                                placeholder="Rechercher dans cette catégorie"
                                aria-label="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                            <div className="row" id="plats-card">
                            {selectedCategory === '' ? (
            // Affiche une image pour "Toutes les catégories"
            <div className="col-12 text-center" >
                <Carousel className="custom-carousel">
                    <Carousel.Item>
                        <img
                            className="d-block w-100 img-couv"
                            src="https://firebasestorage.googleapis.com/v0/b/restaurant-426210.appspot.com/o/carousel%2Fcocktail%20istanbul.jpg?alt=media&token=7d659078-9858-4725-a102-9c56226976fc"
                            alt="cocktail istanbul"
                        />
                
                    </Carousel.Item>

                    <Carousel.Item>
                        <img
                            className="d-block w-100 img-couv"
                            src="https://firebasestorage.googleapis.com/v0/b/restaurant-426210.appspot.com/o/carousel%2F2pides.jpg?alt=media&token=b60ebab7-3735-4518-86ff-14eeb9a3e786"
                            alt="2pides"
                        />
                    </Carousel.Item>

                    <Carousel.Item>
                        <img
                            className="d-block w-100 img-couv"
                            src="https://firebasestorage.googleapis.com/v0/b/restaurant-426210.appspot.com/o/carousel%2Flahmacun.jpg?alt=media&token=83b32313-956b-4e45-b3e7-6011718c7349"
                            alt="lahmacun"
                        />
                    </Carousel.Item>
                </Carousel>




                <div className='card-mot'>
                <p className="mot-chef">L'équipe du restaurant Istanbul est heureux de vous mettre à disposition notre nouvelle plateforme pour les commandes à emporter.</p>
                <p className="mot-chef">
                Certains produits de notre carte ne sont pas disponibles à la commande à emporter en raison de l'impossibilité de le conditionner pour le transport ou tout simplement parce que le plat perdrait sa valeur gustative.</p>
                <p className="mot-chef">
                Restez connecté, un programme de fidélité sera bientôt intégré pour toute personne ayant créé un compte ! </p>
                <p className="mot-chef grand-mot">Bon appétit!</p>
                {/* <div className='card-UBEREATS'>
                <p className="mot-chef">Vous souhaitez être livré? Vous pouvez commander par <Link className='link-UBEREATS' to=""> UBEREATS</Link> </p>
                <img
                    src="https://firebasestorage.googleapis.com/v0/b/restaurant-426210.appspot.com/o/images%2Fimages.png?alt=media&token=c6cc22e5-5116-4b95-8bb7-2e3f9abdee13"
                    alt="UBEREATS"
                    className="img-UBEREATS"
                />
                </div> */}
            </div></div>
        ) : (filteredPlats.map(plat => (
                                <div className="col-md-6 mb-5 pr-4" key={plat.id}>
                                <div className="card h-100 bg-light card-pl ">
                                {plat.image  && (
                                    <img src={plat.image} className="card-img-top img-pl" alt={plat.nom} />
                                )}    
                                    <div className="card-body card-inf d-flex flex-column ">
                                        <h5 className="tl-pl">
                                        {plat.vegetarienne && (
                                            <FontAwesomeIcon 
                                                icon={faCircle} 
                                                className="me-2" 
                                                style={{ color: '#17a517', fontSize: '12px' }} 
                                            />
                                        )}
                                        {plat.nom}</h5>
                                        <p className="pl-text" style={{ whiteSpace: 'pre-line' }}>{plat.description}</p>
                                        <div className="d-flex ">
                                            <p className="pl-price">
                                            <strong>
                                                {plat?.prixType === 'variable' 
                                                ? plat.sizes.map(size => `${size.prix}€`).join(' - ') 
                                                : `${plat.prix}€`}
                                            </strong>

                                            </p>
                                            {(plat.disponible) && (
                                            <Link
                                                className="btn-add-cart"
                                                onClick={() => handleAddToPanier(plat)}
                                            ><FontAwesomeIcon icon={faPlus} /></Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            )))}
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="bg-cart rounded">
                    <h5 className='tl-cart'>Récapitulatif de commande</h5>
                    <ul className="list-group mt-4">
                        {parsedPanier.map(item => (
                        <li
                            key={item.id}
                            className="mt-5"
                        >
                            <div className='cart-item'>  <span className='qt-cart mr-2'>{item.quantity} x</span> {item.nom}</div>
                            <div className="d-flex align-items-center justify-content-start">
                                <div className='col-2 '>
                                <Link
                            className="btn-item"
                            onClick={() => removeFromPanier(item.id)}
                            ><FontAwesomeIcon icon={faMinus} /></Link>
                                </div>
                                <div className='col-8'>
                                <span className='pr-cart'>{(item.prix * item.quantity).toFixed(2)}€ </span>
                                </div>
                                <div className='col-2'>
                                <Link
                                    className="btn-item"
                                    onClick={() => addToPanier(item, 1)} 
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                </Link>
                                </div>
                           
                        
                           
                            </div>
                             
                            
                        </li>
                        ))}
                    </ul>
                   
                    <button
                        className="vl-cart mt-5"
                        onClick={handleCheckout}
                        disabled={parsedPanier.length === 0}
                    >
                        Valider le panier
                    </button>
                    </div>
                    {/* <div className="card-msg-promo">
                        <p className='msg-promo'>Code promo <strong>10%</strong>: istanbul10 (*valable pour les <strong>100</strong> premières commandes)</p>
                    </div> */}
                </div>
            </div>



                {/* Panier */}
               
            </div>


            {/* basePriceal for Pickup Time */}
            <Modal show={showPickupTimeModal} onHide={() => setShowPickupTimeModal(false)} centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className='py-5'>
                <Modal.Title className="text-center w-100 modal-titre mb-3">Heure de retrait</Modal.Title>
                   <p className="text-center w-100 modal-text">Choisissez l'heure à laquelle vous souhaitez passer récupérer votre commande.</p>
                    <Form>
                        <Form.Group controlId="pickupTime">
                        <div className="d-flex justify-content-center">
                            <div className='col-6'>
                            <Form.Control
                                className={`form-modal ${pickupTimeError ? 'is-invalid' : ''}`}
                                as="select"
                                value={pickupTime}
                                onChange={(e) => {
                                    setPickupTime(e.target.value);
                                    if (pickupTimeError) {
                                        setPickupTimeError(false); // Supprimer l'erreur dès qu'une valeur est sélectionnée
                                    }
                                }}
                                required
                            >
                                <option value="">Sélectionner une heure</option>
                                {availablePickupTimes.map((time, index) => (
                                    <option key={index} value={time}>{time}</option>
                                ))}
                            </Form.Control>
                            {pickupTimeError && (
                                <div className="invalid-feedback" style={{ color: 'red' }}>
                                    Veuillez sélectionner une heure de récupération.
                                </div>
                            )}
                            </div>
                            <div className='col-6'>
                            <Button className='btn-size btn-org w-100' onClick={handlePickupTimeSubmit}>Confirmer</Button>
                            </div>
                        </div>    
                        </Form.Group>
                       
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal for Quantity */}
            <Modal show={showQuantityModal} onHide={() => setShowQuantityModal(false)} centered>
  <Modal.Header closeButton></Modal.Header>
  <Modal.Body>
    <div>
      {/* Nom et description du plat */}
      <h5 className="mb-2 modal-tl">{selectedPlat?.nom}</h5>
      <p className="text-muted modal-text" style={{ whiteSpace: 'pre-line' }}>{selectedPlat?.description}</p>
      
      {/* Image du plat */}
      {selectedPlat?.image  && (
      <img src={selectedPlat?.image} className="img-fluid mb-3" alt={selectedPlat?.nom} style={{ width: '100%', maxHeight: '300px', objectFit: 'cover' }} />
      )}
      {/* Si le prix est variable, afficher les tailles */}
      {selectedPlat?.prixType === 'variable' && (
        <div className="mb-3">
          <label>Choisir la taille :</label>
          {selectedPlat.sizes.map((size, index) => (
            size.prix ? ( // Vérifier que le prix n'est pas vide
              <div key={index} className="form-check">
                <input
                  type="radio" // Radio, car une seule taille doit être sélectionnée
                  className="form-check-input"
                  checked={selectedSize?.taille === size.taille} // Vérifie si cette taille est déjà sélectionnée
                  onChange={() => handleSizeSelection(size)} // Met à jour la taille sélectionnée
                />
                <label className="form-check-label">
                  {size.taille} - {size.prix} €
                </label>
              </div>
            ) : null // Ne pas afficher la taille si le prix est vide
          ))}
        </div>
      )}

      {/* Sélecteur de modules (addons) */}
      {selectedPlat?.addons && (
        <div className="mb-3">
          {selectedPlat.addons.length !== 0 && (
            <label>Ajouter des extras :</label>
          )}
          {selectedPlat.addons.map((addon, index) => (
            <div key={index}>
              <strong>{addon.nom}</strong>
              {addon.modules.map((module, modIndex) => (
                <div key={modIndex} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={module.nom}
                    id={`addon-${addon.id}-module-${modIndex}`}
                    onChange={(e) => handleModuleSelection(selectedPlat.id, addon.id, addon.nom, module, e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor={`addon-${addon.id}-module-${modIndex}`}>
                    {module.nom} - {module.prix} €
                  </label>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* Special Instructions Field */}
      <div className="mb-3">
        <label htmlFor="specialInstructions">Instructions spéciales :</label>
        <textarea
          id="specialInstructions"
          className="form-control"
          rows="3"
          placeholder="Ajouter des instructions spéciales..."
          value={specialInstructions}
          onChange={(e) => setSpecialInstructions(e.target.value)}
        />
      </div>

      {/* Sélecteur de quantité */}
      <div className="d-flex justify-content-center align-items-center mb-3">
        <div className="d-flex justify-content-center col-4 align-items-center">
          <Button variant="outline-secondary" className='btn-qt' onClick={() => setQuantity(Math.max(1, quantity - 1))}>
            <FontAwesomeIcon icon={faMinus} />
          </Button>
          <span className="mx-3 coler-black">{quantity}</span>
          <Button variant="outline-secondary" className='btn-qt' onClick={() => setQuantity(quantity + 1)}>
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </div>
        <div className="col-8">
          <Button className="w-100 btn-size btn-org" onClick={handleQuantitySubmit}>
            Ajouter au panier - {calculateTotalPrice()} €
          </Button>
        </div>
      </div>
    </div>
  </Modal.Body>
</Modal>



  {/* Modal for Statut commande */}
  <Modal show={showDisableCommModal}   centered>
  <Modal.Header closeButton></Modal.Header>
  <Modal.Body>
    <div>
      <h5 className="mb-2 modal-tl p-4 text-center">Le réstaurant ne reçoit pas des commandes en ce moment</h5>
      <p className="text-muted modal-text"></p>
     
    </div>
  </Modal.Body>
</Modal>

 {/* Modal de fermeture de restaurant */}
 <Modal show={showFermetureModal}   centered>
  <Modal.Header closeButton></Modal.Header>
  <Modal.Body>
    <div>
      <h5 className="mb-2 modal-tl  p-4 text-center">Le restaurant est fermé</h5>
      <p className="text-muted modal-text"></p>
     
    </div>
  </Modal.Body>
</Modal>
        </div>
    );
};

export default Boutique;
